import Firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';
import 'firebase/analytics';

// Allow either CRA-style REACT_APP_* or Next-style NEXT_PUBLIC_* env names so the
// same build can run in multiple environments without patching code.
const env = process.env;

const config = {
  apiKey: env.REACT_APP_API_KEY,
  authDomain: env.REACT_APP_AUTH_DOMAIN,
  databaseURL: env.REACT_APP_DB_URL,
  projectId: env.REACT_APP_PROJECT_ID,
  storageBucket: env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: env.REACT_APP_MESSAGING_SENDER_ID,
};

if (!config.apiKey) {
  console.warn('[Firebase] Missing API key – check your environment variables.');
}

export const firebase = Firebase.initializeApp(config);

export const auth = firebase.auth();
export const googleProvider = new Firebase.auth.GoogleAuthProvider();
export const appleProvider = new Firebase.auth.OAuthProvider('apple.com');

export const database = firebase.database();
export const storage = firebase.storage();
// export const analytics = firebase.analytics(); // TODO: Setup firebase analytics
